import classnames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import ProductCorePrice from "component/product/ProductCorePrice";
import { RootState } from "interfaces/generics.type";
import Price from "modules/components/prices/price/Price";
import PriceRange from "modules/components/prices/range-price/PriceRange";
import SavedPrice from "modules/components/prices/saved-price/SavedPrice";
import WasPrice from "modules/components/prices/was-price/WasPrice";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { savingsPercentage } from "util/helper/priceDifference";
import HideIf from "util/HideIf";
import ProductRewardsBadge from "../product-rewards/ProductRewardsBadge";
import styles from "./product-price.module.scss";

function ProductPrice(props: any) {
  const {
    price = 0, wasPrice = 0, maximumPrice = 0, minimumPrice = 0, corePrice = 0, size, savePriceStyle, productPriceClassName,
    priceRangeTextClassName, priceRangeValueClassName, displayInOneLine, sameSize, shortFormSavedPrice, color,
    corePriceSize, showSavedPrice = true, sticky = false, productSku = "", isCompact,
  } = props;
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation("product");

  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);

  return (
    <>
      <div
        className={classnames({
          [styles.displayInOneLine]: displayInOneLine,
          "flex-column": !displayInOneLine,
          [styles.price_container]: true,
          [productPriceClassName]: true,
        }, "font-bold align-items-center flex-wrap")}
      >

        <HideIf show={price}>
          <div className={styles.price}>
            <HideIf show={!isCompact}>
              <ProductRewardsBadge sticky={sticky} sku={productSku} />
            </HideIf>

            <Price
              size={size}
              {...{ price }}
              className={classnames(`p-r-5 ${styles.actual_price} m-b-5`, {
                custom_color: color,
              })}
              sameSize={sameSize}
              color={color}
            />

            <HideIf show={!businessCustomer}>
              <WasPrice {...{ wasPrice, price }} />
            </HideIf>
            <HideIf show={isCompact && wasPrice !== price}>
              <div className={styles.short_saved_price}>
                <PAText fontSize={FONT_SIZE[0]}>
                  {savingsPercentage(wasPrice, price)}
                </PAText>
              </div>
            </HideIf>
          </div>
          <HideIf show={!businessCustomer && showSavedPrice && !isCompact}>
            <SavedPrice {...{ wasPrice, price }} className={savePriceStyle} shortForm={shortFormSavedPrice} />
          </HideIf>

          {
            corePrice > 0 && <ProductCorePrice {...{ corePrice }} corePriceSize={corePriceSize} />
          }
        </HideIf>

        <HideIf show={minimumPrice >= 0 && maximumPrice >= 0 && price === 0}>

          <Text className={`m-r-5 ${priceRangeTextClassName}`} size={6} type={TEXT_TYPE.secondary}>{`${t("STARTING FROM")}:`}</Text>

          <PriceRange className={`${styles.priceRangeValueStyle} ${priceRangeValueClassName}`} {...{ minimumPrice, maximumPrice }} />
        </HideIf>
      </div>
    </>
  );
}

export default ProductPrice;
